import { useState, useEffect, useMemo } from 'react';
import { API_URL, MSG } from '../utils/constants';

export function useRecords(token) {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const fetchRecords = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/records`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error(MSG.FETCH_ERROR);
      const data = await response.json();
      
      // receipt_date(접수일) 기준 최신순 정렬
      const sortedData = data.sort((a, b) => new Date(b.receipt_date) - new Date(a.receipt_date));
      setRecords(sortedData);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) fetchRecords();
  }, [token]);

  const filteredRecords = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    
    // 검색어 없으면 전체 반환 (slice 제거)
    if (!term) return records;

    const onlyNumbers = term.replace(/[^0-9]/g, '');
    const isNumeric = onlyNumbers.length > 0;

    // 요청하신 검색 제한 조건
    if (isNumeric && term.length < 4) return []; // 숫자 포함 시 4자 미만 검색 안함
    if (!isNumeric && term.length < 2) return []; // 문자만 있을 시 2자 미만 검색 안함

    return records.filter((record) => {
      const id = String(record.id || '');
      const company = (record.company_name || '').toLowerCase();
      const manager = (record.manager || '').toLowerCase();
      const phone = (record.phone || '').toLowerCase();
      const mobile = (record.mobile || '').toLowerCase();
      const details = (record.receipt_details || '').toLowerCase();
      
      return id.includes(term) ||
	         company.includes(term) || 
             manager.includes(term) || 
             phone.includes(term) || 
             mobile.includes(term) ||
             details.includes(term);
    });
  }, [records, searchTerm]);

  return { 
    records: filteredRecords, 
    totalCount: records.length,
    searchTerm, 
    setSearchTerm, 
    loading, 
    error, 
    refresh: fetchRecords 
  };
}